import { render, staticRenderFns } from "./FulfillmentStockRequests.vue?vue&type=template&id=b6db069e"
import script from "./FulfillmentStockRequests.vue?vue&type=script&lang=js"
export * from "./FulfillmentStockRequests.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentStockRequests.vue?vue&type=style&index=0&id=b6db069e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports